import { render, staticRenderFns } from "./DeficientTransactions.vue?vue&type=template&id=32afb4fb&scoped=true&"
import script from "./DeficientTransactions.vue?vue&type=script&lang=js&"
export * from "./DeficientTransactions.vue?vue&type=script&lang=js&"
import style0 from "./DeficientTransactions.vue?vue&type=style&index=0&id=32afb4fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32afb4fb",
  null
  
)

export default component.exports